<template>
  <div class="employee-management">

    <a-row>
      <a-col :span="6">
        <div class="fs-20  fs-b f-c-b mb-20">部门列表</div>

        <a-input-search style="margin-bottom: 8px" placeholder="搜索部门" @change="onChange" />
        <a-tree
          class="tree-border"
          :selectable="false"
          :replace-fields="{
            children:'childList',
            title:'departmentname', key:'departmentid'
          }"

          :auto-expand-parent="autoExpandParent"
          :expanded-keys="expandedKeys"
          :tree-data="gData"
          @expand="onExpand"
        >
          <template slot="title" slot-scope="row">

            <span v-if="row.departmentname.indexOf(searchValue) > -1" class="tree-item">
              {{ row.departmentname.substr(0, row.departmentname.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{ row.departmentname.substr(row.departmentname.indexOf(searchValue) + searchValue.length) }}
              <span class="action">
                <a-icon type="plus" @click="add(row)" />
                <a-icon type="minus" @click="del(row)" />
                <!-- <a-icon type="edit" /> -->
              </span>
            </span>
            <span v-else class="tree-item">
              {{ row.departmentname }}
              <span class="action">
                <a-icon type="plus" @click="add(row)" />
                <a-icon type="minus" @click="del(row)" />
              </span>
            </span>

          </template>
        </a-tree>
      </a-col>
      <a-col :span="18" class="pl-40 ">
        <div class="fs-20 fs-b f-c-b mb-20">员工列表</div>
        <a-table :columns="columns" :row-key="getKey" :data-source="list" :pagination="pagination" @change="handleTableChange">
          <div slot="positiontype" slot-scope="row">
            {{ +row.positiontype === 1||+row.positiontype === 3?'管理员':'普通员工' }}
          </div>
          <div slot="action" slot-scope="row">
            <span v-if="+row.positiontype === 2" class="f-c-blue pointer" @click="delEmployee(row)">删除</span>
            <span v-if="+row.positiontype === 2" class="ml-10 f-c-blue pointer" @click="restPassword(row)">密码重置</span>
          </div>
          <div slot="footer"><a-button type="primary" @click="showAddEmp = true">添加员工</a-button></div>
        </a-table>
      </a-col>
    </a-row>
    <a-modal v-model="visible" title="添加部门" ok-text="确认" cancel-text="取消" @ok="addDepartment" @cancel="visible = false">
      <a-input v-model="dName" placeholder="请输入部门名称" />
    </a-modal>
    <PostEmployee :viz.sync="showAddEmp" @ok="getEmployeeList({pageIndex:1})" />
  </div>
</template>
<script>
const columns = [
  { title: '昵称', width: 180, dataIndex: 'staffname', key: 'staffname' },
  { title: '登录账号', width: 180, key: 'username', dataIndex: 'username' },
  { title: '所属部门', dataIndex: 'departmentname', key: 'departmentname' },
  { title: '职位', key: 'positiontype', scopedSlots: { customRender: 'positiontype' }},
  { title: '创建时间', dataIndex: 'createtime', key: 'createtime' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }}
]
const setSlotScoped = (list) => {
  list.forEach(element => {
    element.scopedSlots = { title: 'title' }
    if (element.childList && element.childList.length > 0) {
      setSlotScoped(element.childList)
    }
  })
}
const getParentKeys = (list, value, res) => {
  list.forEach(element => {
    if (element.departmentname.indexOf(value) > -1) {
      res.push(element.parentid)
    }
    if (element.childList && element.childList.length > 0) {
      getParentKeys(element.childList, value, res)
    }
  })
}
const getAllParentKeys = (list, res) => {
  list.forEach(element => {
    // if (element.departmentname.indexOf(value) > -1) {
    res.push(element.departmentid)
    // }
    if (element.childList && element.childList.length > 0) {
      getAllParentKeys(element.childList, res)
    }
  })
}
import PostEmployee from '@/components/postEmployee'
export default {
  name: 'EmployeeManagement',
  components: {
    PostEmployee
  },
  data() {
    // data函数返回的对象是具有双向绑定的数据，更新data里面的数据，可以触发ui的变化
    return {
      columns,
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      },
      showAddEmp: false,
      visible: false,
      expandedKeys: [],
      searchValue: '',
      dName: '',
      cItem: null,
      autoExpandParent: true,
      gData: [
        {
          'createtime': '',
          'departmentid': 0,
          'departmentname': this.$store.state.user.company,
          'parentid': 0,
          'status': 0,
          childList: []
        }
      ],
      list: [],
      form: {
        'departmentid': 0,
        'parentId': 0,
        'positiontype': '',
        'staffname': '',
        'username': ''
      }
    }
  },
  watch: {
    expandedKeys(n) {
    }
  },
  async created() {
    // 组件创建时，这个函数就会被触发
    console.log('i am created')
    this.getDepartments()
    this.getEmployeeList()
    // this.userInfo = res
  },
  methods: {
    // staffResetStaffPwd
    restPassword(row) {
      this.$confirm({
        title: '提示',
        content: '确定重置该员工密码？',
        okType: 'danger',
        onOk: async() => {
          const res = await this.$http({ ...this.$api.staffResetStaffPwd, origin: true }, {
            userid: row.userid
          })
          if (res.data.state === 'success') {
            this.$message.success('重置该用户密码成功')
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },
    async getEmployeeList(p) {
      const params = {}
      params.pageIndex = this.pagination.current
      params.pageSize = this.pagination.pageSize
      if (p) {
        Object.assign(params, p)
      }
      const res = await this.$http(this.$api.staffGetStaff, params)
      this.list = res.list || []
      this.pagination.current = res.pageIndex
      this.pagination.pageSize = res.pageSize
      this.pagination.total = res.totalSize
    },
    async handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getEmployeeList()
    },
    async addDepartment() {
      if (!this.dName) {
        this.$message.warning('请输入部门名称')
        return
      }
      const res = await this.$http({ ...this.$api.departmentAddDepartment, origin: true }, {
        'departmentName': this.dName,
        'parentId': this.cItem.departmentid
      })
      if (res.data.state === 'success') {
        this.getDepartments()
        this.visible = false
      } else {
        this.$message.error(res.data.msg)
      }
    },
    async delEmployee(row) {
      this.$confirm({
        title: '提示',
        content: '确定删除该员工',
        okType: 'danger',
        onOk: async() => {
          const res = await this.$http({ ...this.$api.staffDelStaff, origin: true }, {
            'userid': row.userid
          })
          if (res.data.state === 'success') {
            this.getEmployeeList()
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },
    async getDepartments() {
      const res = await this.$http(this.$api.departmentGetDepartment, {})
      const gData = [...this.gData]
      gData[0].childList = res
      setSlotScoped(gData)
      this.gData = gData
      const expandedKeys = []
      getAllParentKeys(this.gData, expandedKeys)
      Object.assign(this, {
        expandedKeys,
        autoExpandParent: true
      })
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    async add(row) {
      this.cItem = row.dataRef
      this.dName = ''
      this.visible = true
    },
    async del(row) {
      this.$confirm({
        title: '提示',
        content: '确定删除该部门',
        okType: 'danger',
        onOk: async() => {
          const res = await this.$http({ ...this.$api.departmentDelDepartment, origin: true }, {
            'departmentId': row.dataRef.departmentid,
            'parentId': row.dataRef.parentid
          })
          if (res.data.state === 'success') {
            this.getDepartments()
          } else {
            this.$message.error(res.data.msg)
          }
        },
        onCancel() {}
      })
    },
    getKey(row) {
      return row.userid
    },
    onChange(e) {
      const value = e.target.value
      const expandedKeys = []
      getParentKeys(this.gData, value, expandedKeys)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      })
    }
  }
}
</script>

<style lang="scss" >
.tree-border{
  border: 1px solid #dedede;
}
.employee-management {
  .tree-item{
    .action{
      margin-left: 20px;
      display: inline;
      .anticon {
        margin-right: 5px;
      }
    }
    &:hover{
      .action{
        display: inline;
      }
    }
  }
}
</style>
